/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const FinancialAvailability = zod
  .enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE", "NOT_PRICED"])
  .describe(
    "AVAILABLE requires the value. RESTRICTED is a disclosure restriction, UNAVAILABLE is a business-source\/input defect, and NOT_PRICED means an admitted coefficient decision is still absent. Non-AVAILABLE states omit the value, never substitute zero. Technical failures remain failed operations.",
  );

export type FinancialAvailability = zod.input<typeof FinancialAvailability>;
export type FinancialAvailabilityOutput = zod.output<typeof FinancialAvailability>;
